import { gql } from "@apollo/client";

const GET_PROFILE_COMPLETION = gql`
  query getProfileCompletion {
    profileCompletion @client
  }
`;

export { GET_PROFILE_COMPLETION };
